import { SidebarBtn } from "./SidebarButtons";
import { FlexColumn } from "@/components/Flex";
import { themeColors } from "@/utils/themeColors";
import { Exam } from "@knowt/syncing/graphql/schema";
import { cleanTitle } from "@knowt/syncing/utils/stringUtils";
import { examNameToUrlComponent } from "@knowt/syncing/hooks/exams/utils";

const StudyGuides = ({ examData }: { examData: Exam }) => {
    const examUnits = examData?.units || [];

    if (!examData || !examUnits.length) return null;

    return (
        <FlexColumn style={{ gap: "1.2rem" }}>
            <span
                className="secondaryTextBold1"
                data-testid="auto-id-d60613be-cd56-4ef3-bf11-7db76d9e2c39">{examData.name} Study Guides</span>
            {examData?.noteId && (
                <SidebarBtn
                    sx={{
                        background: themeColors.neutralWhite,
                        minHeight: "5rem",
                        border: `1px solid ${themeColors.neutral1}`,
                        fontSize: "1.2rem",
                        "&:hover": { boxShadow: "none", backgroundColor: themeColors.neutral1 },
                    }}
                    href={`/note/${examData.noteId}/${cleanTitle(`${examData.name}-Ultimate-Guide`)}`}
                    label={`${examData.name} Ultimate Guide`}
                />
            )}
            {examUnits.map(unit =>
                unit ? (
                    <SidebarBtn
                        key={unit.name}
                        sx={{
                            background: themeColors.neutralWhite,
                            minHeight: "5rem",
                            border: `1px solid ${themeColors.neutral1}`,
                            fontSize: "1.2rem",
                            "&:hover": { boxShadow: "none", backgroundColor: themeColors.neutral1 },
                        }}
                        href={`/note/${unit.noteId}/${cleanTitle(unit.name)}`}
                        label={unit.name}
                    />
                ) : null
            )}
            <SidebarBtn
                sx={{
                    background: themeColors.subject2,
                    minHeight: "5rem",
                    marginTop: "1.5rem",
                    fontSize: "1.2rem",
                    "&:hover": { boxShadow: "none", backgroundColor: themeColors.docsMed },
                }}
                href={`/exams/${examData.type}/${examNameToUrlComponent(examData.name)}`}
                label={
                    <div
                        className="bold"
                        style={{ fontSize: "1.2rem" }}
                        data-testid="auto-id-7155ed5b-d065-45ff-8f06-4a67dc222d28">
                        Studying for another AP Exam?
                    </div>
                }
                misc={
                    <div
                        className="bold"
                        style={{ fontSize: "1.2rem" }}
                        data-testid="auto-id-c1c484c7-4818-4d4c-b339-8615aaef47dd">
                        Check out our other AP study guides
                    </div>
                }
            />
        </FlexColumn>
    );
};

export default StudyGuides;
